import api from "../api";

export const contactsService = {
  list: async (params = {}) => {
    const res = await api.get("/api/persons/persons/", { params });
    const results = Array.isArray(res.data?.data) ? res.data.data : [];
    return {
      results,
      count: res.data?.count ?? results.length,
      next: res.data?.next ?? null,
      previous: res.data?.previous ?? null,
    };
  },

  positions: async (params = {}) => {
    const res = await api.get("/api/persons/positions/", { params });
    const results = Array.isArray(res.data?.data) ? res.data.data : [];
    return {
      results,
      count: res.data?.count ?? results.length,
      next: res.data?.next ?? null,
    };
  },

  getDetail: async (id) => {
    const res = await api.get(`/api/persons/persons/${id}/`);
    return res.data?.data ?? res.data;
  },

  getLeads: async (id) => {
    const res = await api.get(`/api/persons/persons/${id}/leads/`);
    const results = Array.isArray(res.data?.data) ? res.data.data : [];
    return {
      results,
      count: res.data?.count ?? results.length,
    };
  },

  create: async (payload) => {
    const res = await api.post("/api/persons/persons/", payload);
    return res.data?.data ?? res.data;
  },

  merge: async (personIds, personPayload = null) => {
    const res = await api.post("/api/persons/persons/merge/", {
      person_ids: personIds,
      ...(personPayload ? { person: personPayload } : {}),
    });
    return res.data?.data ?? res.data;
  },

  update: async (id, payload) => {
    const res = await api.patch(`/api/persons/persons/${id}/`, payload);
    return res.data?.data ?? res.data;
  },

  remove: async (id) => {
    await api.delete(`/api/persons/persons/${id}/`);
  },

  importPreview: async ({ accountId, file }) => {
    const form = new FormData();
    if (accountId) form.append("account_id", accountId);
    form.append("file", file);
    const res = await api.post("/api/persons/import/preview/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  importConfirm: async (importId, { validateEmails = false } = {}) => {
    const res = await api.post(`/api/persons/import/${importId}/confirm/`, {
      validate_emails: validateEmails,
    });
    return res.data;
  },

  getImport: async (importId) => {
    const res = await api.get(`/api/persons/import/${importId}/`);
    return res.data;
  },

  downloadImportTemplate: async () => {
    const res = await api.get("/api/persons/import/template/", {
      responseType: "blob",
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "template_import_contactos.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
